import React from 'react'
import './styles.css'

interface TagProps {
    value: string,
    variant: 'prod' | 'test',
    onClick(e: any): any,
    role?: string
}

export default function Tag(props: TagProps): JSX.Element {

    return (
        <div id='tag-wrapper' tabIndex={0} role={props.role} className={`tag-wrapper ${props.variant}`} onClick={props.onClick}>
            <h5 id="tag-version" className={`value-text ${props.variant}`}>{props.value}</h5>
        </div>
    )
}